module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-coins-sm-93277fd86ba8c43284d996ec77bbc57a.svg";